export default __webpack_public_path__ + "assets/cash-payment.c14e603d.svg";